// extracted by mini-css-extract-plugin
export default {"cHeader":"Header_cHeader__sS4qH"};